import React, { FC } from "react";
interface TransactionPageProps {}

const TransactionPage: FC<TransactionPageProps> = () => {
  return <div>transaction page</div>;
};

export default TransactionPage;
